import clsx from 'clsx'
import Image from 'next/image'
import { memo } from 'react'

import css from '@/molecules/FansiWinCard/css/index.module.css'

function Cover(props: CoverProps) {
  const { src, name, layout } = props

  return (
    <figure
      className={clsx([css['product-cover']], {
        [css['product-cover--flex']]: layout === 'flex',
        [css['product-cover--grid']]: layout === 'grid',
      })}
    >
      {src && (
        <Image
          alt={name}
          src={src}
          layout="fill"
          objectFit="cover"
          className="select-none rounded-2xl"
          priority
          quality={75}
          loading="eager"
        />
      )}
    </figure>
  )
}

interface CoverProps {
  src: string
  name: string
  layout: 'flex' | 'grid'
  id?: number
  refetch?: () => void
}

export default memo(Cover)
